
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import descriptor from './BehaviouralModelLineageDescriptor.json'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default defineComponent({
    name: 'behavioural-model-lineage',
    components: { DataTable, Column },
    props: { tableData: { type: Array as any, required: true }, headerTitle: String, dataType: String, loading: Boolean },
    data() {
        return {
            descriptor,
            filterFields: ['name', 'label'],
            columns: [
                { field: 'name', header: 'common.label' },
                { field: 'label', header: 'common.name' }
            ],
            filters: { global: [filterDefault] } as Object,
            selectedRow: {} as any
        }
    },
    created() {},
    methods: {}
})
